// KD-3907: a refresh token works once. Parallel 401s, in this tab or another
// one sharing localStorage, would each spend the same token and all but the
// first would fail, logging the user out. The Web Locks API runs one refresh
// at a time across tabs; whoever waited reuses the token the winner stored.
const LOCK = 'koob-session-refresh';

const bearerOf = (request) =>
  `${request?.headers?.Authorization ?? ''}`.replace(/^Bearer /, '');

const withLock = (task) =>
  typeof navigator !== 'undefined' && navigator.locks
    ? navigator.locks.request(LOCK, task)
    : task();

/**
 * A fresh access token for a request refused with a 401, or null when there
 * is none to get: the request already retried, no session to refresh, or the
 * refresh failed. `refresh` posts the stored refresh token to oauth/token.
 */
export const freshAccessToken = async (request, refresh) => {
  if (
    !request ||
    request._hasBeenRetried ||
    request.url?.includes('oauth/token') ||
    !localStorage.getItem('refreshToken')
  ) {
    return null;
  }
  request._hasBeenRetried = true;
  const sent = bearerOf(request);

  return withLock(async () => {
    const current = localStorage.getItem('accessToken');
    if (current && current !== sent) return current;
    // A refresh that failed while we waited: the session is over.
    if (!localStorage.getItem('refreshToken')) return null;
    try {
      const { data } = await refresh();
      localStorage.setItem('accessToken', data.accessToken);
      localStorage.setItem('refreshToken', data.refreshToken);
      return data.accessToken;
    } catch {
      localStorage.setItem('refreshToken', '');
      return null;
    }
  });
};
